import { render, staticRenderFns } from "./NuevoTurno.vue?vue&type=template&id=6e7e368a"
import script from "./NuevoTurno.vue?vue&type=script&lang=js"
export * from "./NuevoTurno.vue?vue&type=script&lang=js"
import style0 from "./NuevoTurno.vue?vue&type=style&index=0&id=6e7e368a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports